import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {
  EuiAvatar,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHeaderSectionItemButton,
  EuiHorizontalRule,
  EuiLink,
  EuiSpacer,
  EuiText,
  htmlIdGenerator,
  EuiIcon,
} from "@elastic/eui";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import Popover from "components/Popover/Popover";
import { authSelector } from "reduxStore/auth/auth.selectors";
import { isSubjectAuthorizedForUser } from "utils";
import { Roles, Subjects } from "settings/permissions";
import "styles/global/page.css";

export const HeaderUserMenu = ({ setIsMyProfileVisible }: any) => {
  const navigate = useNavigate();
  const appInsights = useAppInsightsContext();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { currentUser } = useSelector(authSelector, shallowEqual);

  const id = htmlIdGenerator()();

  const onMenuButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const canViewUserProfile = isSubjectAuthorizedForUser({
    subject: Subjects.User_Profile,
    role: Roles.Read,
  });
  const canEditUserProfile = isSubjectAuthorizedForUser({
    subject: Subjects.User_Profile,
    role: Roles.Write,
  });

  const button = (
    <EuiHeaderSectionItemButton
      aria-controls={id}
      aria-expanded={isOpen}
      aria-haspopup="true"
      aria-label="Accounts menu"
      onClick={onMenuButtonClick}>
      {/* @ts-ignore */}
      <EuiAvatar
        color="#2bbc86"
        iconColor="#fff"
        id="header-avatar"
        name={`${currentUser.firstName}`}
        size="m"
      />
    </EuiHeaderSectionItemButton>
  );

  return (
    <Popover
      anchorPosition="upLeft"
      button={button}
      onClose={closeMenu}
      isOpen={isOpen}
      children={
        <div className="profilePopup">
          <EuiFlexGroup
            className="profileRow"
            gutterSize="m"
            responsive={false}
            // tabIndex="1"
            style={{ paddingTop: 16, paddingLeft: 16 }}>
            <EuiFlexItem grow={false} style={{ paddingTop: 6 }}>
              {/* @ts-ignore */}
              <EuiAvatar
                color="#2bbc86"
                iconColor="#fff"
                name={`${currentUser.firstName}`}
                size="m"
              />
            </EuiFlexItem>

            <EuiFlexItem>
              <EuiText>
                <p>{`${currentUser.firstName} ${currentUser.lastName}`}</p>
              </EuiText>
              <EuiText size="xs">
                <p>{`${currentUser.emailAddress}  `}</p>
              </EuiText>
              {canViewUserProfile && <EuiSpacer size="s" />}
            </EuiFlexItem>
          </EuiFlexGroup>

          <EuiHorizontalRule margin="s" />
          {canViewUserProfile && (
            <EuiFlexGroup direction="column" gutterSize="m" style={{ paddingLeft: 16 }}>
              <EuiFlexItem grow={false}>
                <EuiLink
                  autoFocus={false}
                  color="text"
                  id="edit-profile"
                  onClick={() => {
                    setIsMyProfileVisible(true);
                    closeMenu();
                  }}
                  type="button">
                  <EuiIcon type="user" />
                  <span className="profilePopupLinkText">
                    {canEditUserProfile ? "Edit Profile" : "View Profile"}
                  </span>
                </EuiLink>
              </EuiFlexItem>
            </EuiFlexGroup>
          )}

          <EuiHorizontalRule margin="s" />
          <EuiLink
            autoFocus={false}
            color="text"
            onClick={() => {
              appInsights?.trackEvent({ name: "Logout Link" });
              navigate("/logout");
            }}
            style={{ paddingBottom: 16, paddingTop: 5, paddingLeft: 16 }}>
            <EuiIcon type="logOut" />
            <span className="profilePopupLinkText">Log Out</span>
          </EuiLink>
        </div>
      }
    />
  );
};
